
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'
import UserItem from '@/components/Profile/Lists/Single/UserItem.vue'
import { useProfileUserBlock } from '@/composables/userBlock/userBlock'

export default defineComponent({
  name: 'BlockedUserItem',
  emits: ['removed'],
  components: {
    UserItem,
    AButton,
  },
  props: {
    bannedUser: {
      type: Object,
      default: {},
    },
  },
  setup(props, context) {
    const { isBlocking, unblockUser: unblockUserApi } = useProfileUserBlock(
      props.bannedUser.blocked.id
    )

    const unblockUser = () => {
      unblockUserApi()
      context.emit('removed', props.bannedUser.blocked.id)
    }

    return {
      isBlocking,
      unblockUser,
      ...useRouter(),
    }
  },
})
